import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule } from 'ionic-angular';
import { Braintree } from '@ionic-native/braintree';
import { HardcopyHeaderComponent } from './components/header/header';
import { HardcopyPurchaseBar } from './components/purchase-bar/purchase-bar';
import { HardcopyCustomerDetailsPage } from './pages/customer-details/customer-details';
import { HardcopyIntroPage } from './pages/intro/intro';
import { HardcopyPostageCostPage } from './pages/postage-cost/postage-cost';
import { HardcopyQuantityPage } from './pages/quantity/quantity';
import { HardcopyShippingAddressPage } from './pages/shipping-address/shipping-address';
import { HardcopyOrderTotalPage } from './pages/order-total/order-total';

@NgModule({
    declarations: [
        HardcopyCustomerDetailsPage,
        HardcopyHeaderComponent,
        HardcopyIntroPage,
        HardcopyOrderTotalPage,
        HardcopyPostageCostPage,
        HardcopyPurchaseBar,
        HardcopyQuantityPage,
        HardcopyShippingAddressPage,
    ],
    entryComponents: [
        HardcopyCustomerDetailsPage,
        HardcopyIntroPage,
        HardcopyOrderTotalPage,
        HardcopyPostageCostPage,
        HardcopyQuantityPage,
        HardcopyShippingAddressPage,
    ],
    exports: [
        HardcopyCustomerDetailsPage,
        HardcopyIntroPage,
        HardcopyOrderTotalPage,
        HardcopyPostageCostPage,
        HardcopyQuantityPage,
        HardcopyShippingAddressPage,
    ],
    imports: [
        BrowserModule,
        IonicModule,
    ],
    providers: [
        Braintree,
    ],
})
export class PurchaseHardcopyModule { }



// WEBPACK FOOTER //
// ./src/pages/purchase-hardcopy/module.ts